import { render, staticRenderFns } from "./OtherDocuments.vue?vue&type=template&id=39a2c5b0&"
import script from "./OtherDocuments.vue?vue&type=script&lang=js&"
export * from "./OtherDocuments.vue?vue&type=script&lang=js&"
import style0 from "./OtherDocuments.vue?vue&type=style&index=0&id=39a2c5b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./OtherDocuments.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports